import script from "./tipModal.vue?vue&type=script&setup=true&lang=js"
export * from "./tipModal.vue?vue&type=script&setup=true&lang=js"

import "./tipModal.vue?vue&type=style&index=0&id=d2d264d2&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2d264d2"]])

export default __exports__